var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoApthai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.986,
    height: 117.471,
    viewBox: "0 0 73.986 117.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-170.987 -131.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M187.883,229.222H177.372v97.026h52.556V315.467H187.883Z",
    transform: "translate(-4.885 -79.222)",
    fill: "#e4873c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 10.511,
    height: 10.781,
    transform: "translate(222.922 225.465)",
    fill: "#7cb956"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 10.511,
    height: 10.781,
    transform: "translate(182.527 143.336)",
    fill: "#7cb956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M232.627,304.687V229.222H222.116v86.245H264.16V304.687Z",
    transform: "translate(-40.019 -79.222)",
    fill: "#c82129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M273.252,137.44v10.781h40.543v86.245h10.511V137.44Z",
    transform: "translate(-80.833 -4.885)",
    fill: "#859bcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M273.252,183.331v10.781h30.032v75.464h10.511V183.331Z",
    transform: "translate(-79.969 -39.995)",
    fill: "#743b8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 31.533,
    height: 71.349,
    transform: "translate(192.213 154.116)",
    fill: "#59142f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M192.748,131.055v10.416H181.142v10.416H170.987v96.64h53.675V238.112h10.155V227.695h10.155v-96.64Zm50.775,95.191H233.368v10.417H223.213v10.415H172.436V153.336h10.155V142.92h10.157v31.3l-11.858,31.2h6.387l1.959-5.208h11.545L198.852,195H191.19L195.8,182.49l8.622,22.924h11.533V179.375h7.092a5.971,5.971,0,0,1,5.971,6.074v0a5.971,5.971,0,0,1-5.971,6.074H217.41v5.208h5.763c7.125,0,11.645-4.892,11.645-11.284s-4.52-11.284-11.645-11.284H210.156v29.819l-11.269-29.821H194.2V132.5h49.326Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApthai);
export default __webpack_public_path__ + "static/media/logo-apthai.6c7da69765141e243e850030eda0a332.svg";
export { ForwardRef as ReactComponent };